export default [
  {
    path: "/",
    component: () => import("src/pages/ElectionDashboard.vue"),
  },
];
